import { useEffect } from 'react'

import { HandlerFormComponent } from 'modules/workflows/contexts/WorkflowContext'

export const EmptyHandlerForm = ({ onChange }: HandlerFormComponent) => {
  useEffect(() => {
    onChange({}, true)
  }, [])

  return null
}
